import { GetClientInstance } from "./ApiClientService";

export const GetAccessTokenByTokenKey = async (documentId) => {
    let client = await GetClientInstance(false);

    return client
        .get(`adapters/documents/${documentId}/credentials`)
}
